import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/sanju/Desktop/office project/redcard/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/sanju/Desktop/office project/redcard/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/sanju/Desktop/office project/redcard/src/components/Navbar.tsx");
